<template>
  <div>
    <div id="app">
      <div class="container">
        <div class="main-content">
          <div class="result-panel">
            <div class="result-header">
              <h2><i class="fas fa-list-alt"></i> 差异结果</h2>
              <div class="legend">
                <div class="legend-item">
                  <div class="color-box added"></div>
                  <span>新增属性</span>
                </div>
                <div class="legend-item">
                  <div class="color-box removed"></div>
                  <span>删除属性</span>
                </div>
                <div class="legend-item">
                  <div class="color-box modified"></div>
                  <span>修改属性</span>
                </div>
              </div>
             <div class="json-diff-container" v-html='renderDiff("root", this.oldData, this.newData, "root")'>
             
             </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: {
    oldData: {
      type: [Object, Array],
      required: true,
    },
    newData: {
      type: [Object, Array],
      required: true,
    },
  },
  data() {
    return {
      expandedKeys: new Set(),
    };
  },
  methods: {
    toggleExpand(key) {
      if (this.expandedKeys.has(key)) {
        this.expandedKeys.delete(key);
      } else {
        this.expandedKeys.add(key);
      }
    },

    isObject(obj) {
      return obj !== null && typeof obj === "object";
    },

    renderDiff(key, oldVal, newVal, path = "") {
      const currentPath = path ? `${path}.${key}` : key;
      const isExpanded = this.expandedKeys.has(currentPath);

      if (oldVal === newVal) {
        return this.renderUnchanged(key, oldVal, currentPath);
      }

      if (oldVal === undefined) {
        return this.renderAdded(key, newVal, currentPath);
      }

      if (newVal === undefined) {
        return this.renderRemoved(key, oldVal, currentPath);
      }

      if (this.isObject(oldVal) && this.isObject(newVal)) {
        return this.renderObjectDiff(
          key,
          oldVal,
          newVal,
          currentPath,
          isExpanded
        );
      }

      return this.renderModified(key, oldVal, newVal);
    },

    renderUnchanged(key, value, path) {
      return `
            <div class="json-diff-item">
              <span class="json-key">"${key}"</span><span class="json-colon">:</span> ${this.formatValue(
        value,
        path
      )}
            </div>
          `;
    },

    renderAdded(key, value, path) {
      return `
            <div class="json-diff-item json-added">
              <span class="json-key">"${key}"</span><span class="json-colon">:</span> ${this.formatValue(
        value,
        path
      )}
            </div>
          `;
    },

    renderRemoved(key, value, path) {
      return `
            <div class="json-diff-item json-removed">
              <span class="json-key">"${key}"</span><span class="json-colon">:</span> ${this.formatValue(
        value,
        path
      )}
            </div>
          `;
    },

    renderModified(key, oldVal, newVal) {
      return `
            <div class="json-diff-item json-modified">
              <span class="json-key">"${key}"</span><span class="json-colon">:</span> 
              <span class="json-removed">${this.formatSimpleValue(
                oldVal
              )}</span> 
              <i class="fas fa-arrow-right" style="margin: 0 5px; color: #6c757d;"></i>
              <span class="json-added">${this.formatSimpleValue(newVal)}</span>
            </div>
          `;
    },

    renderObjectDiff(key, oldVal, newVal, path, isExpanded) {
      const allKeys = new Set([...Object.keys(oldVal), ...Object.keys(newVal)]);

      let childrenHtml = "";
      if (isExpanded) {
        childrenHtml = Array.from(allKeys)
          .map((childKey) =>
            this.renderDiff(childKey, oldVal[childKey], newVal[childKey], path)
          )
          .join("");
      } else {
        childrenHtml =
          '<span class="json-toggle" onclick="this.__vue__.toggleExpand(\'' +
          path +
          "')\">...</span>";
      }

      return `
            <div class="json-diff-item">
              <span class="json-key">"${key}"</span><span class="json-colon">:</span> 
              <span class="json-bracket">{</span>
              ${childrenHtml}
              <span class="json-bracket">}</span>
            </div>
          `;
    },

    formatValue(value, path) {
      if (this.isObject(value)) {
        const isExpanded = this.expandedKeys.has(path);
        if (isExpanded) {
          const keys = Object.keys(value);
          const children = keys
            .map((key) => this.renderDiff(key, value[key], value[key], path))
            .join("");

          return `<span class="json-bracket">{</span>${children}<span class="json-bracket">}</span>`;
        } else {
          return `<span class="json-bracket">{</span> <span class="json-toggle" onclick="this.__vue__.toggleExpand('${path}')">...</span> <span class="json-bracket">}</span>`;
        }
      }

      return this.formatSimpleValue(value);
    },

    formatSimpleValue(value) {
      if (typeof value === "string") {
        return `"${value}"`;
      }
      if (Array.isArray(value)) {
        return `[${value.map((v) => this.formatSimpleValue(v)).join(", ")}]`;
      }
      return String(value);
    },
  },
  mounted() {
    this.$el.__vue__ = this;
  },
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
body {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: #333;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
  min-height: 100vh;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
}
header {
  text-align: center;
  margin-bottom: 30px;
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
h1 {
  color: #2c3e50;
  margin-bottom: 10px;
}
.description {
  color: #7f8c8d;
  max-width: 800px;
  margin: 0 auto;
}
.main-content {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}
.input-panel {
  flex: 1;
  min-width: 300px;
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.input-group {
  margin-bottom: 20px;
}
.input-group h3 {
  margin-bottom: 10px;
  color: #3498db;
  display: flex;
  align-items: center;
}
.input-group h3 i {
  margin-right: 10px;
}
textarea {
  width: 100%;
  height: 200px;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-family: "Courier New", monospace;
  font-size: 14px;
  resize: vertical;
}
.controls {
  text-align: center;
  margin: 20px 0;
}
button {
  background: #3498db;
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
button i {
  margin-right: 8px;
}
button:hover {
  background: #2980b9;
}
.result-panel {
  flex: 2;
  min-width: 500px;
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}
.legend {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}
.legend-item {
  display: flex;
  align-items: center;
  font-size: 14px;
}
.color-box {
  width: 16px;
  height: 16px;
  margin-right: 5px;
  border-radius: 3px;
}
.added {
  background-color: #d4edda;
}
.removed {
  background-color: #f8d7da;
}
.modified {
  background-color: #fff3cd;
}
.json-diff-container {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 15px;
  border: 1px solid #e1e4e8;
  border-radius: 5px;
  background-color: #fafbfc;
  max-height: 600px;
  overflow: auto;
}
.json-diff-item {
  margin-left: 20px;
}
.json-key {
  color: #953800;
  font-weight: 500;
}
.json-added {
  color: #22863a;
  background-color: #f0fff4;
  padding: 2px 0;
}
.json-removed {
  color: #cb2431;
  background-color: #ffeef0;
  padding: 2px 0;
  text-decoration: line-through;
}
.json-modified {
  color: #b08800;
  background-color: #fffdef;
  padding: 2px 0;
}
.json-toggle {
  cursor: pointer;
  color: #0366d6;
  margin-right: 4px;
  width: 15px;
  display: inline-block;
}
.json-bracket {
  color: #24292e;
  font-weight: bold;
}
.json-colon {
  color: #24292e;
  font-weight: bold;
  margin: 0 3px;
}
.error-message {
  color: #e74c3c;
  margin-top: 10px;
  text-align: center;
  font-weight: 500;
}
footer {
  text-align: center;
  margin-top: 30px;
  color: #7f8c8d;
  font-size: 14px;
}
@media (max-width: 768px) {
  .main-content {
    flex-direction: column;
  }
}
</style>


